import React, { useState, useEffect } from 'react';
import { Navigate, useParams } from "react-router-dom";
import { Button } from "@mui/material";

import Grid from '@mui/material/Grid2';

import { FeatureSource, ModelBase, PlayerObject } from "@models";
import { 
  Gift, 
} from "@dndModels";

import StringBox from "@components/input/strings/StringBox";
import LoadingBox from "@components/input/LoadingBox";
import CheckBox from "@components/input/CheckBox";

import FeatureSourceInput from "@dndComponents/FeatureSourceInput";

import API from "@dndUtilities/system_api";
import CommonUtilities from "@utilities/common_utilities";
import SuggestionStringBox from "@dndComponents/select/SuggestionStringBox";

const api = API.getInstance();
const common_util = CommonUtilities.getInstance();

export default function GiftEdit() {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [fetched, setFetched] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [navigateTo, setNavigateTo] = useState<string | null>(null);
  const [obj, setObj] = useState<Gift>(api.applyWorkingOn(new Gift()));
  const [change_time, setChangeTime] = useState(0);
  const [tab, setTab] = useState("Description");
  
  const disabled = api.user === null || !api.online || (!api.user.admin && obj._id !== "" && obj.owner_id !== api.user._id);
  
  useEffect(() => {
    if(!fetched) {
      load();
    }
  });

  const load = () => {
    setFetched(true);
    if (id && id !== "") {
      setLoading(true);
      const onComplete = (res: PlayerObject[] | ModelBase[]) => {
        if (res.length === 1 && res[0] instanceof Gift) {
          setObj(res[0]);
          setChangeTime(common_util.get_time_number());
        }
        setLoading(false);
      };
      const onProgress = () => {};
      api.getObjectsWithCallbacks({ 
        data_type: "gift", filter: { _id: id },
        onComplete, onProgress 
      });
    }
  }

  const submit = () => {
    if (api.user && 
      (api.user.admin || 
        obj._id === "" || 
        obj.owner_id === api.user._id)) {
      setProcessing(true);
      if (!api.user.admin || obj.source_books_old.filter(o => o.id === "Personal").length > 0) {
        obj.owner_id = api.user._id;
      } else if (api.user.admin && obj.source_books_old.filter(o => o.type === "Homebrew").length === 0) {
        obj.owner_id = "";
      }
      api.upsertObject("gift", obj).then(res => {
        setProcessing(false);
        setNavigateTo("/dandd/gift");
      });
    }
  }


  const height = window.innerHeight - 64;
  if (!fetched || loading) {
    return (<LoadingBox size={height * 0.5} height={height} width={window.innerWidth} />);
  } else if (navigateTo !== null) {
    return <Navigate to={navigateTo} />;
  } else { 
    // console.log(obj);
    return (
      <div style={{ height }}>
        <Grid container spacing={0} direction="row" style={{ height: "100%" }}>
          <Grid
            container
            spacing={0}
            direction="row"
            style={{ height: (tab === "Description" ? (height - 61) : height) }}
            size={{
              xs: 12
            }}>
            <Grid
              style={{ height: "100%" }}
              size={{
                xs: 12
              }}>
              <FeatureSourceInput 
                obj={obj}
                data_type="gift"
                disabled={disabled}
                change_time={change_time}
                onChange={(changed: FeatureSource) => {
                  if (changed instanceof Gift) {
                    const new_obj = obj;
                    new_obj.copy(changed);
                    setObj(new_obj);
                  }
                }}
                onTabChange={(changed: string) => {
                  setTab(changed);
                }}
              >
                <Grid container spacing={0} direction="row">
                  <Grid
                    size={{
                      xs: 12
                    }}>
                    <SuggestionStringBox 
                      name="Type"
                      field="gift_type"
                      value={obj.type} 
                      disabled={disabled}
                      onChange={(changed: string) => {
                        const new_obj = obj;
                        new_obj.type = changed;
                        setObj(new_obj);
                        setChangeTime(common_util.get_time_number());
                      }}
                    />
                  </Grid>
                  <Grid
                    size={{
                      xs: obj.use_gift_levels ? 6 : 12
                    }}>
                    <CheckBox name="Use Gift Levels"
                      value={obj.use_gift_levels} 
                      disabled={disabled}
                      onChange={(value: boolean) => {
                        const new_obj = obj;
                        new_obj.use_gift_levels = value;
                        setObj(new_obj);
                        setChangeTime(common_util.get_time_number());
                      }}
                    />
                  </Grid>
                  { obj.use_gift_levels &&
                    <Grid
                      size={{
                        xs: 6
                      }}>
                      <StringBox 
                        name="Max Level"
                        value={`${obj.max_level}`} 
                        type="number"
                        onBlur={(value: string) => {
                          const new_obj = obj;
                          new_obj.max_level = +value;
                          setObj(new_obj);
                          setChangeTime(common_util.get_time_number());
                        }}
                      />
                    </Grid>
                  }
                </Grid>
              </FeatureSourceInput>
            </Grid>
          </Grid>
          { !disabled && tab === "Description" &&
            <Grid
              size={{
                xs: 12
              }}>
              <Button
                variant="contained"
                color="primary"
                disabled={processing}
                onClick={submit}>
                Submit
              </Button>
              <Button
                variant="contained"
                disabled={processing}
                style={{ marginLeft: "4px" }}
                onClick={ () => { 
                  setNavigateTo(`/dandd/gift`);
                }}>
                Cancel
              </Button>
            </Grid>
          }
        </Grid>
      </div>
    ); 
  }
}